(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutePubblicheController', SedutePubblicheController);

    SedutePubblicheController.$inject = ['$state', '$stateParams', 'SedutaPubblica', 'Documento', 'FileSaver','paginationConstants', 'legislaturaDetails', 'PaginationUtil','toastr'];

    function SedutePubblicheController($state, $stateParams,  SedutaPubblica, Documento, FileSaver, paginationConstants, legislaturaDetails, PaginationUtil, toastr) {
        var vm = this;


        vm.legislaturaDetails = legislaturaDetails;
        vm.legislatura = $stateParams.legislatura;
        vm.idOrganismo = $stateParams.idOrganismo;
        vm.tipoOrganismo = $stateParams.tipoOrganismo;
        vm.anno = $stateParams.anno;
        vm.page = $stateParams.page;
        vm.sort = $stateParams.sort;
        vm.predicate = PaginationUtil.parsePredicate($stateParams.sort),
        vm.ascending = PaginationUtil.parseAscending($stateParams.sort),

        vm.itemsPerPage = paginationConstants.itemsPerPage;
        
        vm.sedute = [];
        vm.organismo = {};
        vm.anniDisponibili = [];

        vm.caricaSedute = caricaSedute;
        vm.transition = transition;
        vm.downloadDocument = downloadDocument;
        vm.getOdgTitle = getOdgTitle;

        init();

        function init() {
            caricaDettagliOrganismo();
            calcolaAnniDisponibili(vm.legislaturaDetails.validityStartDate, vm.legislaturaDetails.validityEndDate);
            caricaSedute();
            
        }

        function calcolaAnniDisponibili(startDate, endDate) {
            var annoInizio = new Date(startDate).getFullYear();
            var annoCorrente = new Date().getFullYear();
            var annoFine;
            if(!endDate) {
                annoFine = annoCorrente;
            } else {
                annoFine = new Date(endDate).getFullYear();
            }
            if(!vm.anno) {
                vm.anno = annoCorrente;
            }

            for (var i = annoInizio; i <= annoFine; i++) {
                vm.anniDisponibili.push(i);
            }
        }

        function caricaDettagliOrganismo() {

            if (!vm.idOrganismo) {
                return;
            }

            if (vm.tipoOrganismo === 'C') {

                SedutaPubblica.getDettagliCommissione({ idCommissione: vm.idOrganismo }, onSuccessGetOrganismo, onErroGetOrganismo);
            } else {
                SedutaPubblica.getDettagliSoggettoEsterno({ idSoggettoEsterno: vm.idOrganismo }, onSuccessGetOrganismo, onErroGetOrganismo);
            }
        }

        function onSuccessGetOrganismo(result) {
            vm.organismo = result;
        }

        function onErroGetOrganismo(error) {
            toastr.error("Errore nel recupero dei dettagli dell'organismo", error);
        }

        function caricaSedute() {

            SedutaPubblica.query({
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                legislatura: vm.legislatura,
                idOrganismo: vm.idOrganismo,
                tipoOrganismo: vm.tipoOrganismo,
                anno: vm.anno
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sedute = data;
            }

            function onError(error) {
                toastr.error("Errore nel caricamento delle sedute", error);
                vm.sedute = [];
            }
        }

        function downloadDocument(docId, docName) {
            Documento.getDocSedutaContent(docId).then(function (result) {
                if (result) {
                    FileSaver.saveAs(new Blob([result.data], {}), docName);
                }
            }, function () {
                toastr.error('Impossibile scaricare il documento', 'Errore!');
            });
        }

        function transition(resetPage) {

            if(resetPage) {
                vm.page = 1;
            }
        
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                idOrganismo: vm.idOrganismo,
                tipoOrganismo: vm.tipoOrganismo,
                legislatura: vm.legislatura,
                anno: vm.anno
            });

        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];      
            return result;
        }

        function getOdgTitle(index) {
            if (index === 0) return "Ordine del giorno";
            return "ODG Aggiuntivo";
        }
    }
})();

